'use client';
import styled from '@benzinga/themetron';
import { PreferencesToggleNew } from './toggleNew';
import React from 'react';

interface SwitchBoxV2Props {
  fontSize: string;
  title: string;
  active: boolean;
  PostIcon?: React.ReactNode;
  onClick(value: boolean | string): void;
}

export const SwitchBoxV2: React.FC<SwitchBoxV2Props> = props => {
  const handleClick = React.useCallback(() => {
    props.onClick(!props.active);
  }, [props]);

  return (
    <Wrapper onClick={handleClick}>
      <SwitchWrapper>
        <TitleWrapper>{props.title}</TitleWrapper>
        <PreferencesToggleNew active={props.active} fontSize={props.fontSize} onClick={props.onClick} />
      </SwitchWrapper>
      {props.PostIcon}
    </Wrapper>
  );
};

const TitleWrapper = styled.div`
  align-items: center;
  font-family: 'Nimbus Sans D OT';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

const SwitchWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
  gap: 8px;
  flex-grow: 1;
  &:hover {
    cursor: pointer;
  }
`;

const Wrapper = styled.div`
  display: flex;
  border-radius: 5px;
  color: ${props => props.theme.colors.foregroundActive};
  border: 1px solid ${props => props.theme.colors.border};
  justify-content: space-between;
  align-items: center;

  position: relative;
`;
